export default {
    'title.activety': '活动',
    'title.giftCard': 'Instachef',
    'title.giftCardResult': '礼品卡兑换结果',
    'title.giftHistory': '礼品卡兑换历史'
}